import { appRoutesConst } from "app/navigation";
import { listingReducer } from "reducers/utils/listingReducer";
import { getAppointmentsList } from "../services/appointments";

const actionTypes = {
  ON_PATIENT_SELECT: "ON_PATIENT_SELECT",
  ON_SET_PATIENT_APPOINTMENT: "ON_SET_PATIENT_APPOINTMENT",
};

const { reducer, actions, types } = listingReducer({
  name: `appointments`,
  getApi: getAppointmentsList,
});

const onSetPatient = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.ON_PATIENT_SELECT, payload: data });
  };
};

const onSetPatientAppointment = (data,navigateTo) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.ON_SET_PATIENT_APPOINTMENT, payload: data });
    navigateTo(appRoutesConst.videocall);
  };
};

const appointments = reducer;
export { appointments, actions, types, onSetPatient, onSetPatientAppointment };
